<template>
  <listheader v-if="listItems.length > 0"/>
  <listitem
    @click="goToNoticia(item)"
    :item="item" :key="item.ID" v-for="item in listItems"/>
  <slot></slot>
</template>

<script>
import listheader from './listheader.vue';
import listitem from "./listitem.vue";
import { useRouter } from 'vue-router';
import { useDetailStore } from '@/stores/detail.js'; 


export default {
  props:["listItems"],
  components:{
    listheader,
    listitem
  },
  setup(props) {

    const router = useRouter();
    const store = useDetailStore();

    const goToNoticia = (item) => {
      store.setCurrentDetailItem(item);
      router.push({path: `/noticias-e-eventos/${item.ID}`})
    }

    return {
      goToNoticia
    }
  }
}
</script>

<style>

</style>